<template>
  <div>
    <v-card elevation="0">
      <HomeBidangMainCarousel :itemsCarousel="carouselItems1"></HomeBidangMainCarousel>

      <div :class="$vuetify.breakpoint.smAndDown ? 'ml-2 ' : 'ml-16' " class="mt-10" style="position: absolute; z-index: 4; top: 50px; left: 0;" v-if="!currentUserAdmin">
        <v-card-title class="blue--text headline font-weight-black">
          SISTEM INFORMASI JASA KONSTRUKSI (SMART-EJAKON)
        </v-card-title>
        <v-card-subtitle class="white--text">
          <v-row >
            <v-col cols="10" sm="10" md="4">
              Sistem Informasi Jasa Konstruksi Kabupaten Kotawaringin Barat yang mencakup pelatihan dan sertifikasi serta marketplace jasa konstruksi            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-btn
              v-if="!currentUserWebinar"
              @click="toLogin"
              width="150px"
              color="success"
              dark>
            Sign In
          </v-btn>
          <v-btn
              v-if="!currentUserWebinar"
              @click="toRegister"
              class="ml-2"
              width="150px"
              color="primary"
              dark>
            Sign Up
          </v-btn>
        </v-card-actions>

      </div>

    </v-card>

    <div class="py-16">
      <div class="header-title pb-12">
        <span class="text-h6 font-weight-medium">Berita Terbaru</span>
        <v-img :src="src2"></v-img>
      </div>
      <div>
        <v-container>
          <v-layout wrap justify-center class="d-flex mt-2">
            <div v-for="(item, i) in fNewsFiltered" :key="i">
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                      width="330"
                      min-height="600"
                      xs12
                      sm4
                      px-3
                      class="ma-3 rounded-lg pb-6"
                      :elevation="hover ? 16 : 3"
                  >
                    <div>
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-img
                              height="250"
                              :lazy-src="lookupImageUrlLazy(item)"
                              :src="lookupImageUrl(item)"
                              :class="{ 'hover-image': hover }"
                              class="rounded-lg"
                          ></v-img>
                        </template>
                      </v-hover>
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text class="mb-1">
                      <div class="subtitle-1 font-weight-black">
                        {{ item.title }}
                      </div>
                      <div class="text-caption">
                        {{ computedDateFormattedDatefns(item.dateFrom) }}
                      </div>
                      <div class="text-subtitle-2 mt-3 grey--text text--darken-1">
                        {{ item.contentMeta }}
                      </div>
                    </v-card-text>
                    <v-card-text>
                      <v-row align="start" class="px-3">
                        <div v-html="`${item.contentBody}...`"></div>
                        <v-btn
                            outlined
                            small
                            class="caption font-weight-bold primary--text mt-2"
                            @click="routeToAgenda(item)"
                        >
                          Selengkapnya
                        </v-btn>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </v-hover>
            </div>
          </v-layout>
          <v-row
              class="mt-8"
              justify="center"
              align="center"
              v-if="pageSize <= 5"
          >
            <v-btn @click="growFNews" dark color="amber darken-2">Tampilkan Lebih Banyak
              <v-icon class="ml-2">mdi-chevron-down</v-icon></v-btn
            >
          </v-row>
          <v-row
              class="mt-8"
              justify="center"
              align="center"
              v-if="pageSize >= 5"
          >
            <v-btn @click="unGrowFNews" dark color="amber darken-2">
              Tampilkan Lebih Sedikit
              <v-icon class="ml-2">mdi-chevron-up</v-icon>
            </v-btn>
          </v-row>
        </v-container>
      </div>
    </div>

    <div class="py-16 mx-16">
      <div class="header-title pb-12">
        <span class="text-h6 font-weight-medium">Bidang</span>
        <v-img :src="src2"></v-img>
      </div>
      <v-layout wrap justify-center class="d-flex mt-5 mx-9">
        <div v-for="(itemFDivision, i) in itemsFDivisionFiltered" :key="i">
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-card
                width="220"
                height="210"
                xs12
                sm4
                px-3
                class="ma-4 rounded-lg"
                :elevation="hover ? 16 : 3"
              >
                <div>
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <router-link
                        style="text-decoration: none"
                        :to="`/pu/` +
                          linkNeated(itemFDivision.kode2.toString())
                        "
                      >
                        <v-img
                          height="140px"
                          :lazy-src="lookupAvatarUrlLazy(itemFDivision)"
                          :src="lookupAvatarUrl(itemFDivision)"
                          :class="{ 'hover-image': hover }"
                          class="rounded-lg"
                        >
                        </v-img>
                      </router-link>
                    </template>
                  </v-hover>
                </div>


                <v-card-text>
                  <div class="subtitle-2 text-center font-weight-black">
                    {{ itemFDivision.description }}
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </v-hover>
        </div>
      </v-layout>
    </div>


  </div>
</template>

<script>
import FDivisionService from "@/services/apiservices/f-division-service";
import FNewsService from "@/services/apiservices/f-news-service";
import FileService from "@/services/apiservices/file-service";

import FNews from "@/models/f-news";

import { format, parseISO } from "date-fns";
import FtDataFileService from "@/services/apiservices/ft-data-file-service";
import ERole from "@/models/e-role";
import HomeBidangMainCarousel from "@/components/public-home/HomeBidangMainCarousel.vue";
export default {
  name:"HomeBidang",
  components: {HomeBidangMainCarousel},
  props: {
    bidang: Object
  },
  data() {
    return {

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 3,
      pageSizes: [3],
      itemsPerSlide: 3,

      model: null,
      search: "",
      fBeritas: [new FNews(1, "001")],
      itemsFDivision: [],
      absoluteBerita: true,
      overlayBerita: null,
      absoluteVideo: true,
      overlayVideo: null,
      carouselItems1: [
        {
          title: "Card 1",
          description: "This is the content of Card 1",
          image: "./assets/carousel/carousel-1.jpeg",
        },
      ],
      carouselItems2: [
        {
          id: 1,
          title: "Smart BMD",
          description:
            "Aplikasi Sistem Informasi Pengamanan Barang Milik Daerah",
          url: "https://smartbmd.kotawaringinbaratkab.go.id/",
          image: "./assets/images/logo-smart-bmd.png",
        },
        {
          id: 1,
          title: "e-RTLH",
          description: "Aplikasi rumah tidak layak huni Kementrian RI",
          url: "https://datartlh.perumahan.pu.go.id/",
          image: "./assets/images/logo-rtlh.png",
        },
      ],
      carouselVideo: [
        {
          title: "Bidang 1",
          description: "This is the content of Card 1",
          image: "./assets/images/gambar1.jpg",
        },
        {
          title: "Bidang 2",
          description: "This is the content of Bidang 2",
          image: "./assets/images/gambar2.jpg",
        },
        {
          title: "Bidang 3",
          description: "This is the content of Bidang 3",
          image: "./assets/images/gambar3.jpg",
        },
        //   { title: 'Card 6', description: 'This is the content of Card 6', image: './assets/images/gambar3.jpg' },
      ],
      itemsPerRow: 3,
      src1: "../assets/images/dayak.png",
      src2: "../assets/images/aksen.png",
      textFieldValue: "",
    };
  },
  watch: {
    bidang: function (val) {
      if (val){
        this.fetchFNews();
        this.fetchFtDataFile()
      }
    },

  },

  computed: {
    itemsFDivisionFiltered() {
      return this.itemsFDivision.filter(
        (item) => item.statusActive===true && item.avatarImage !== ""
      );
    },

    slideApps() {
      const slides = [];
      for (let i = 0; i < this.carouselItems2.length; i += this.itemsPerSlide) {
        slides.push(this.carouselItems2.slice(i, i + this.itemsPerSlide));
      }
      return slides;
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
    fNewsFiltered() {
      let beritasModified = [];
      for (let i = 0; i < this.fBeritas.length; i++) {
        let itemBerita = this.fBeritas[i];
        if (itemBerita.contentBody !== undefined) {
          if (itemBerita.contentBody.length > 150) {
            itemBerita.contentBody = itemBerita.contentBody.substr(0, 149);
          }
        }
        beritasModified.push(itemBerita);
      }

      return beritasModified;
    },

    rowItemsArray() {
      const rows = [];

      for (let i = 0; i < this.carouselItems2.length; i += this.itemsPerRow) {
        const rowItems = this.carouselItems2.slice(i, i + this.itemsPerRow);
        rows.push(rowItems);
      }

      return rows;
    },
    itemsPerPage() {
      return this.itemsPerRow;
    },
    rowItemsArray2() {
      const rows = [];
      const totalItems = this.carouselItems2.length;
      const rowCount = Math.ceil(totalItems / this.itemsPerRow);

      for (let i = 0; i < rowCount; i++) {
        const startIndex = i * this.itemsPerRow;
        const endIndex = startIndex + this.itemsPerRow;
        let rowItems = this.carouselItems2.slice(startIndex, endIndex);

        // Add an extra empty placeholder if row contains only 2 items
        if (rowItems.length === 2) {
          rowItems.push(null);
        }

        // Fill the row with empty placeholders if there are fewer items
        if (rowItems.length < this.itemsPerRow) {
          const emptyItemsCount = this.itemsPerRow - rowItems.length;
          for (let j = 0; j < emptyItemsCount; j++) {
            rowItems.push(null);
          }
        }

        rows.push(rowItems);
      }

      return rows;
    },
    itemsPerPage2() {
      return this.itemsPerRow;
    },
    currentUserAdmin(){
      if(this.$store.state.auth.user){
        return !!this.$store.state.auth.user.roles.includes(ERole.ROLE_ADMIN);
      } else {
        return false
      }
    },
    currentUserWebinar(){
      if(this.$store.state.auth.user){
        return !!this.$store.state.auth.user.roles.includes(ERole.ROLE_USER);
      } else {
        return false
      }
    },
  
  },
  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    toRegister() {
      this.$router.push("/select-account-type");
    },
    routeToAgenda(item) {
      this.$router.push(
        `/public-news-page/` + this.linkNeated(item.id.toString())
      );
    },
    routeToExternalLink(item) {
      window.location.href = item.url;
    },
    growFNews() {
      this.pageSize = 6;
      this.fetchFNews();
    },
    unGrowFNews() {
      this.pageSize = 3;
      this.fetchFNews();
    },
    fetchFNews() {
      FNewsService.getAllFNewsContainingAndFdivisionBeanPublicBerita(
        this.currentPage,
        this.pageSize,
        "created",
        "DESC",
        this.search,
          this.bidang.id
      ).then(
        (response) => {
          // console.log(response.data.items)
          const { items, totalPages } = response.data;
          this.fBeritas = items;
          this.totalPaginationPages = totalPages;

          // console.log(`TotalPage ${totalPages} and TotalItems ${items} `)
        },
        (error) => {
          console.log(error.response);
        }
      );
    },

    fetchFtDataFile(){
      FtDataFileService.findAllFtDataFileByFtDataBeanPublic(this.bidang.id).then(
          response => {
            this.carouselItems1 = []

            response.data.forEach( item =>{
              const data = {
                title: item.title,
                description: item.description,
                image: FileService.image_url_low(item.fileName),
              }
              this.carouselItems1.push(data)
            })


          },
      )
    },

    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },

    lookupAvatarUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_high(item.avatarImage);
      }
    },
    lookupAvatarUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    lookupImageUrl(item) {
      if (item.coverImage === undefined || item.title === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.coverImage);
      }
    },
    lookupImageUrlLazy() {
      return "./assets/images/no_image_available.jpeg";
    },

    computedDateFormattedDatefns(value) {
      return value ? format(parseISO(value), "dd MMM yyyy") : "";
    },
    dateTimeFormat(value) {
      return value ? format(parseISO(value), "dd-MMM-yyyy hh:mm:ss") : "";
    },
    formattedCurrencyValue(prefix, value) {
      if (!value) {
        return "0";
      }
      // return "Rp." + parseFloat(value).toFixed(0).toLocaleString()
      return prefix + "" + parseFloat(value).toLocaleString();
    },
    detailBidang(item) {
      this.$store.dispatch("BidangModule/updateCurrentItemBidang", item);
      this.$router.push("/beranda-detail-bidang");
      window.location.href = "/beranda-detail-bidang";
    },
    setOverlayBerita(index, value) {
      this.overlayBerita = value ? index : null;
    },
    setOverlayVideo(index, value) {
      this.overlayVideo = value ? index : null;
    },
    updateItemsPerSlide() {
      // Update itemsPerSlide based on screen width
      if (window.innerWidth < 600) {
        this.$emit("update:itemsPerSlide", 1);
      } else {
        this.$emit("update:itemsPerSlide", 3);
      }
    },
    fetchParent() {
      // 912346549
      FDivisionService.getAllFDivisionPublic().then((response) => {

        this.itemsFDivision = response.data;
      });
    },
  },
  beforeDestroy() {
    // Clean up the listener
    window.removeEventListener("resize", this.updateItemsPerSlide);
  },
  mounted() {
    window.addEventListener("resize", this.updateItemsPerSlide);
    this.updateItemsPerSlide();
    this.fetchParent();

    // this.fetchFNews();

  },

};
</script>
  
<style scoped>
.text-light-h1 {
}
.card-hover {
  cursor: pointer;
  position: relative;
}

.overlay-text {
  color: #ffffff;
  position: absolute;
  pointer-events: none;
  display: inline-block;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -25%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 99 !important;
  width: 90%;
  /* Adjust the max-width value as needed */
  text-align: left; /* Center the text within the card */
}

.card-hover:hover .overlay-text {
  opacity: 1;
}
.header-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.card-container .v-carousel .v-carousel__controls .v-carousel__controls__item {
  width: 10px !important; /* Adjust the width as desired */
  height: 10px !important; /* Adjust the height as desired */
  background-color: #f44336 !important; /* Adjust the background color as desired */
  border-radius: 50% !important; /* Make it circular */
  margin: 0 5px !important; /* Adjust the margin as desired */
}
/* .card-aplikasi-image {
    object-fit: cover;
    height: 100%;
  } */

.card-image-cover-aps {
  box-sizing: border-box !important;
  object-fit: cover;
}
.card-image-cover-aps .card-image-aps {
  width: 100%; /* Set the width to occupy the entire card */
  height: 200px;
  object-fit: cover;
}
.card-image-cover-bidang {
  box-sizing: border-box !important;
  object-fit: cover;
}
.card-image-cover-bidang .card-image-bidang {
  width: 100%; /* Set the width to occupy the entire card */
  height: 200px;
  object-fit: cover;
}
.v-overlay {
  z-index: 0;
}
.card-image-cover-berita {
  position: relative;
  z-index: 1;
  box-sizing: border-box !important;
  object-fit: cover;
}
.card-image-cover-berita .card-image-berita {
  width: 100%; /* Set the width to occupy the entire card */
  height: 250px;
  object-fit: cover;
}
.card-image-cover-video {
  position: relative;
  z-index: 1;
  box-sizing: border-box !important;
  object-fit: cover;
}
.card-image-cover-video .card-image-video {
  width: 100%; /* Set the width to occupy the entire card */
  height: 300px;
  object-fit: cover;
}

.v-card__text {
  height: 25%;
  overflow: hidden;
}
.banner-image {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.overlay {
  padding: 10% 0;
  position: relative;
  z-index: 99;
  background: linear-gradient(
    180deg,
    rgba(10, 10, 10, 0) 0%,
    rgba(10, 10, 10, 0.17) 18.99%,
    rgba(10, 10, 10, 0.21) 20.34%
  );
  height: 80vh;
  width: 100%;
}
.card-container {
  position: relative;
  z-index: 99;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  /* margin-top: -100px; */
  background: transparent;
}

.floating-card {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .card-container {
    margin-top: 0;
  }
}
</style>